import {ApiClient} from '@hconnect/apiclient'
import {Button} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

const redirectToAuthenticator = () => ApiClient.loginFlow.startLoginProcess()

export const LoginPage: React.FC = () => {
  const {t} = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-page_background">
      <Button onClick={redirectToAuthenticator}>{t('suite.loginButton')}</Button>
    </div>
  )
}
